import React from 'react'
import ReactDOM from 'react-dom/client'
import '@agion/ui/styles.css'
import App from './App'
import './styles/globals.css'
import './core/analytics_i18n'
import { initTelemetry } from '@/core/analytics_telemetry'

initTelemetry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
